const HorizontalDivider = () => {
  return <div className="w-full h-1 border-b border-gray-300 mb-4" />;
};

export default HorizontalDivider;
